import _ from 'lodash'

export default function getFullName(item = {}) {
  if (!!!item) return null
  return _.get(item, 'fullname', '')
}

